import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import $ from 'jquery';
import vypis from './files/vypiszivnost.pdf';
import osvedceni from './files/osvedceniregi.pdf';
import vypisObchodni from './files/obchodnirejstrik.pdf';
import vypisElektro from './files/osvedceni-elektro.pdf';
import RegistraceDPH from './files/registraceDPH.pdf';
/* global google */

var map = null;

class Kontakty extends Component {

    componentDidMount(){

        function resetMenu(){
            $("#home a").removeClass("active");
            $("#sluzby-a-produkty-link a").removeClass("active");
            $("#prodej-instalace-li a").removeClass("active");
            $("#lokalni-li a").removeClass("active");
            $("#outsourcing-li a").removeClass("active");
            $("#audit-is-li a").removeClass("active");
            $("#webhosting-li a").removeClass("active");
            $("#webdesign-li a").removeClass("active");
            $("#cenik-praci-li a").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

        $("#kontakty-li a").addClass("active");

        function initMap(){

            var uluru = {lat: 50.07163754566204, lng:  14.481207298224579};
            var map = new google.maps.Map(document.getElementById('map'), {
                zoom: 12,
                center: uluru
            });
            var marker = new google.maps.Marker({
                position: uluru,
                map: map
            });
        }
        $(document).ready(function() {
            initMap();
        });


    }


  render() {
    return (
<div>
        <div className="container content fade-in two" id="kontakty">
            <h1>Kontakty</h1>

            <div className="col-sm-6">
                <img src={logo} className="kontakty-logo" alt="logo" /><br/><br/>
                servis a prodej IT, outsourcing IT, webhosting, webdesign<br/>
                obchodní, poradenská a zprostředkovatelská činnost<br/><br/>

                <span>
                    <span className="font-14">Společnost je zapsaná u Městského soudu v Praze • Spisová značka C 285836</span><br/>
                    <b>IČ:</b> 06631266 <b>DIČ:</b> CZ06631266<br/>
                    <b>ID datové schránky:</b> hc2vyc6<br/><br/>



                    <span className="font-14"><b >Kancelář a sídlo společnosti:</b> Kubánské nám. 1391/11, 100 00 Praha 10 - Vršovice</span>
<br/>
                    <span className="font-12"><b >Provozovna:</b> Žižkova 286, 251 69 Velké Popovice</span><br/><br/>





                <span className="font-14">
                      <b>Mobil:</b> <a href="tel:+420 733 533 544">+420 733 533 544</a><br/>
                      <b>E-mail:</b> <a href="mailto:info@ricomtech.cz">info@ricomtech.cz</a><br/><br/>
                      <b>Obchodní oddělení:</b> <a href="mailto:obchod@ricomtech.cz">obchod@ricomtech.cz</a><br/>
                      <b>Servis, webhosting:</b> <a href="mailto:servis@ricomtech.cz">servis@ricomtech.cz</a><br/>
                      <b>Webové a mailové servery:</b> <a href="mailto:michal@ricomtech.cz">michal@ricomtech.cz</a><br/>
                      <b>Webdesign – webmaster:</b> <a href="mailto:webmaster@ricomtech.cz">webmaster@ricomtech.cz</a><br/>
                </span>

                </span>
            </div>
            <div className="col-sm-6">
                <div id="map"></div>

                <div className="col-sm-6 padding-0 font-14 banka-kontakty">
                    <b>Banka:</b> Raiffeisenbank a.s.<br/>
                        <b>Číslo účtu:</b> 2401364154/5500<br/>
                            <b>IBAN:</b> CZ2055000000002401364154<br/>
                                <b>Swift adresa:</b> RZBCCZPP<br/><br/>


                </div>
                <div className="col-sm-6  padding-0 font-14  banka-kontakty">
                    <b>Banka:</b> Fio banka, a.s.<br/>
                        <b>Číslo účtu:</b> 2401364154/2010<br/>
                            <b>IBAN:</b> CZ6720100000002401364154<br/>
                                <b>Swift adresa:</b> FIOBCZPPXXX<br/><br/>

                
                </div>


                <a target="_blank" href={"https://or.justice.cz/ias/ui/rejstrik-firma.vysledky?subjektId=995774&typ=PLATNY"}>Výpis z obchodního rejstříku</a><br/>
                <a target="_blank" href={vypis}>Výpis z živnostenského rejstříku</a><br/>
                <a target="_blank" href={RegistraceDPH}>Osvědčení o registraci DPH</a><br/>
                <a target="_blank" href={vypisElektro}>Osvědčení elektro vyhl. 50/1978 sb. </a><br/>


            </div>
            <div id="map-script"></div>
        </div>
</div>

    );
  }
}

export default Kontakty;



// WEBPACK FOOTER //
// ./src/Kontakty.js